import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    fileInput: {
        width: '97%',
        margin: '10px 0',
    },
    upTo2M: {
        color: 'grey',
        fontSize: '12px',
    },
    imageParentDiv:{
        height: '300px',
        width: '300px',
        position: 'relative',
        padding: '0',
    },
    profileImage:{
        height: '300px',
        width: '300px',
        objectFit: 'contain',
        border: '2px solid orange'
    },
    signupButton: {
        color: 'white',
        background: '#F3923D',
        borderRadius: '32.83px',
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        marginRight: 25,
        fontFamily: 'Noto Sans JP, sans-serif',
    },
    loginButton: {
        color: '#F3923D',
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        background: '#FFFFFF',
        border: '1px solid #F3923D',
        // box-sizing: border-box;
        borderRadius: '32.83px',
        fontFamily: 'Noto Sans JP, sans-serif',
    },
   
    gridContainer: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },

    },

    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
        },
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        //marginTop: theme.spacing(3),
    },
    googleButton: {
        marginBottom: theme.spacing(2),
    },
    deleteButton:{
        position: 'absolute',
        background: 'rgba(255,255,255,0.5)',
        zIndex: 10,
        padding: '4px 0',
        fontSize: '12px',
        maxWidth: '10px',
        margin: '0',
        top: '10px',
        right: '10px',
    },
    imageEdit: {
        position: 'absolute',
        background: 'rgba(255,255,255,0.5)',
        zIndex: 10,
        margin: '0',
        bottom: '10px',
        left: '50%',
        transform: 'translateX(-50%)',
        WebkitTransform: 'translateX(-50%)',
        padding: '20px 20px'
    },
    uploadIcon:{
        height: '20px',
    },
    uploadText:{
        fontSize: '12px',
    },
    buttonsGrid: {
        margin: "20px auto"
    }

}));